export default __webpack_public_path__ + "images/TZ.c8567fd.png";